import { FC } from 'react';
import { AdminClientLayout } from 'pages/atoms';
import { AdminClientCompanyDetails } from 'containers/admin';

const AdminClientCompanyDetailsPage: FC = () => {
  return (
    <AdminClientLayout>
      <AdminClientCompanyDetails />
    </AdminClientLayout>
  );
};

export default AdminClientCompanyDetailsPage;
